import { defineStore } from "pinia";
import { accountService } from "@/_services";

export const accountStore = defineStore("account", {
  state: () => ({
    account: null,
    accountUpdated: null,
    error: null,
  }),
  actions: {
    getAccount() {
      this.error = null;
      this.accountUpdated = null;
      return accountService
        .getAccount()
        .then((result) => {
          this.account = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    updateAccount(body) {
      this.error = null;
      this.accountUpdated = null;
      return accountService
        .updateAccount(body)
        .then((result) => {
          this.accountUpdated = result;
          this.account = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    clearAccountState() {
      this.accountUpdated = null;
      this.error = null;
    },
  },
});
